import { render, staticRenderFns } from "./sportbook-market.vue?vue&type=template&id=65c2a16d&scoped=true&"
import script from "./sportbook-market.vue?vue&type=script&lang=js&"
export * from "./sportbook-market.vue?vue&type=script&lang=js&"
import style0 from "./sportbook-market.vue?vue&type=style&index=0&id=65c2a16d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c2a16d",
  null
  
)

export default component.exports